import { EventBus, router, store } from "@/internal";
import {
  AxiosError,
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse
} from "axios";
import Cookie from "js-cookie";
import Vue from "vue";
declare module "vue/types/vue" {
  interface VueConstructor {
    // @ts-ignore
    axios: AxiosInstance;
  }
}

export namespace Http {
  export class ApiJwtService {
    protected static clearLocalStorage() {
      store.dispatch("authModule/logout");
    }
    constructor() {
      this.request();
      this.response();
    }

    protected request() {
      Vue.axios.interceptors.request.use(
        (config: AxiosRequestConfig) => {
          const authDataCookie = Cookie.get("auth_data");
          if (authDataCookie) {
            config.headers.Authorization = `Bearer ${authDataCookie}`;
          } else {
            Http.ApiJwtService.clearLocalStorage();
          }
          config.headers.Accept = "application/json";
          config.headers["Content-Type"] = "application/json";
          return config;
        },
        (err: any) => {
          return Promise.reject(err);
        }
      );
    }

    protected response() {
      Vue.axios.interceptors.response.use(
        (response: AxiosResponse) => {
          return response;
        },
        (err: AxiosError) => {
          // redirect to login cuando la respuesta sea 401
          if (err.response && err.response.status === 401) {
            Http.ApiJwtService.clearLocalStorage();
          } else if (err.response && err.response.status === 403) {
            EventBus.$emit("notify", { text: "unauthorized", color: "red" });
          }
          return Promise.reject(err);
        }
      );
    }
  }
}
